import { Extension } from '@tiptap/react';

import '@tiptap/extension-text-style';
import { customNodes } from '../customNodes';

export type LineHeightOptions = {
  types: string[];
};

declare module '@tiptap/react' {
  interface Commands<ReturnType> {
    lineHeight: {
      /**
       * Set the font size
       */
      setLineHeight: (fontSize: string) => ReturnType;
      /**
       * Unset the font size
       */
      unsetLineHeight: () => ReturnType;
    };
  }
}

export const LineHeight = Extension.create<LineHeightOptions>({
  name: 'lineHeight',

  addOptions() {
    return {
      types: ['textStyle']
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: element => element.style.lineHeight.replace(/['"]+/g, ''),
            renderHTML: attributes => {
              if (!attributes.lineHeight) {
                return {};
              }

              return {
                style: `line-height: ${attributes.lineHeight}`
              };
            }
          }
        }
      }
    ];
  },

  addCommands() {
    return {
      setLineHeight:
        lineHeight =>
        ({ chain, tr }) => {
          const from = tr.selection.ranges[0].$from.pos;
          const to = tr.selection.ranges[0].$to.pos;
          tr.doc.descendants((node, pos) => {
            if (customNodes.includes(node.type.name) && pos >= from && pos <= to) {
              tr.setNodeAttribute(pos, 'lineHeight', lineHeight);
            }
          });
          return chain().setMark('textStyle', { lineHeight }).run();
        },
      unsetLineHeight:
        () =>
        ({ chain, tr }) => {
          const from = tr.selection.ranges[0].$from.pos;
          const to = tr.selection.ranges[0].$to.pos;
          tr.doc.descendants((node, pos) => {
            if (customNodes.includes(node.type.name) && pos >= from && pos <= to) {
              tr.setNodeAttribute(pos, 'lineHeight', null);
            }
          });
          return chain().setMark('textStyle', { lineHeight: null }).removeEmptyTextStyle().run();
        }
    };
  }
});
